import React, { useState, useEffect } from "react";
import "./AiCharacter.css";

const AiCharacter = ({ isAnimating = false }) => {
  const [isBlinking, setIsBlinking] = useState(false);
  const [isWhistling, setIsWhistling] = useState(false);

  useEffect(() => {
    const blinkInterval = setInterval(() => {
      setIsBlinking(true);
      setTimeout(() => {
        setIsBlinking(false);
      }, 200); // Blink duration
    }, 7000); // Every 7 seconds

    return () => clearInterval(blinkInterval);
  }, []);

  useEffect(() => {
    const whistleInterval = setInterval(() => {
      if (!isAnimating) {
        // Only whistle when not talking
        setIsWhistling(true);
        setTimeout(() => {
          setIsWhistling(false);
        }, 800); // Whistle duration
      }
    }, 5000); // Every 5 seconds

    return () => clearInterval(whistleInterval);
  }, [isAnimating]);

  return (
    <div className="ai-character-container">
      <svg
        width="50"
        height="50"
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Face circle with gradient */}
        <defs>
          <linearGradient id="faceGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#6c50e9" />
            <stop offset="100%" stopColor="#9783f0" />
          </linearGradient>
          <linearGradient id="eyeGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#ffffff" />
            <stop offset="100%" stopColor="#f0f0f0" />
          </linearGradient>
        </defs>

        {/* Main face */}
        <circle
          cx="50"
          cy="50"
          r="45"
          fill="url(#faceGradient)"
          stroke="#ffffff"
          strokeWidth="2"
          className={isAnimating ? "face-pulse" : ""}
        />

        {/* Left eye */}
        <ellipse cx="38" cy="40" rx="6" ry="8" fill="url(#eyeGradient)" />
        {/* Eyelid for left eye */}
        <ellipse
          cx="38"
          cy="40"
          rx="6"
          ry="8"
          fill="url(#faceGradient)"
          className={
            isAnimating
              ? "eyelid-blink"
              : isBlinking
                ? "eyelid-blink-interval"
                : "eyelid-open"
          }
        />
        <circle
          cx="38"
          cy="40"
          r="3"
          fill="#2d1b69"
          className={isAnimating ? "pupil-move-left" : ""}
        />

        {/* Right eye */}
        <ellipse cx="62" cy="40" rx="6" ry="8" fill="url(#eyeGradient)" />
        {/* Eyelid for right eye */}
        <ellipse
          cx="62"
          cy="40"
          rx="6"
          ry="8"
          fill="url(#faceGradient)"
          className={
            isAnimating
              ? "eyelid-blink"
              : isBlinking
                ? "eyelid-blink-interval"
                : "eyelid-open"
          }
        />
        <circle
          cx="62"
          cy="40"
          r="3"
          fill="#2d1b69"
          className={isAnimating ? "pupil-move-right" : ""}
        />

        {/* Mouth - changes based on animation state */}
        {isAnimating ? (
          <ellipse
            cx="50"
            cy="70"
            rx="8"
            ry="6"
            fill="#2d1b69"
            className="mouth-talk"
          />
        ) : isWhistling ? (
          <circle
            cx="50"
            cy="68"
            r="4"
            fill="none"
            stroke="#2d1b69"
            strokeWidth="2"
            className="mouth-whistle"
          />
        ) : (
          <path
            d="M 40 65 Q 50 75 60 65"
            stroke="#2d1b69"
            strokeWidth="3"
            fill="none"
            strokeLinecap="round"
          />
        )}

        {/* Cheek highlights */}
        <circle
          cx="28"
          cy="55"
          r="4"
          fill="rgba(255, 255, 255, 0.3)"
          className={isAnimating ? "cheek-glow" : ""}
        />
        <circle
          cx="72"
          cy="55"
          r="4"
          fill="rgba(255, 255, 255, 0.3)"
          className={isAnimating ? "cheek-glow" : ""}
        />
      </svg>
    </div>
  );
};

export default AiCharacter;
